import { ScheduleDescriptionApi } from '@apps/rept/api/models';
import { TemplateVersion } from '@apps/rept/rept.constants';

import { Value } from '../../models/value';

export class TemplateApi
{
    public applicationName: string;
    public apiName: string;
    public description: string;
    public canBeContractual: boolean;
    public isPublic: boolean;
    public preferedPeriodicity: number;
    public templateId: string;
    public templateName: string;
    public reportIntervals: ReportInterval[] | null;
    public version: TemplateVersion;
    public contractualSchedule: ScheduleDescriptionApi;
    public displayInPortal: boolean;
}

export class ReportInterval
{
    customInterval: CustomInterval;
    periodicity: number;
    predefIntervals?: Value[] | null;
}

export class CustomInterval
{
    lowerIntervalLimit: string;
    preferedTick: number;
    ticks?: string[] | null;
    upperIntervalLimit: string;
    ticksForCompute?: string[] | null;
}
